const HamburgerIcon = ({ size = 24, color = "currentColor", open}) => {

  return (
    <svg
      className="hamburger-svg cursor-pointer"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <rect
        className="line top"
        x="2"
        y="6"
        width="20"
        height="2"
        rx="1"
        fill={color}
        style={{
          transformOrigin: "center",
          transform: open ? "rotate(45deg) translateY(5px)" : "rotate(0deg)",
          transition: "transform 0.3s ease"
        }}
      />
      <rect
        className="line middle"
        x="2"
        y="11"
        width="20"
        height="2"
        rx="1"
        fill={color}
        style={{
          opacity: open ? 0 : 1,
          transition: "opacity 0.2s ease"
        }}
      />
      <rect
        className="line bottom"
        x="2"
        y="16"
        width="20"
        height="2"
        rx="1"
        fill={color}
        style={{
          transformOrigin: "center",
          transform: open ? "rotate(-45deg) translateY(-5px)" : "rotate(0deg)",
          transition: "transform 0.3s ease"
        }}
      />
    </svg>
  )
}

export default HamburgerIcon
